
import { defineComponent } from 'vue'
import AccountManageHeader from '../components/AccountManageHeader.vue'
import AccountQrcodeVerification from '../components/AccountQrcodeVerification.vue'

export default defineComponent({
  name: 'WechatLogin',
  components: {
    AccountManageHeader,
    AccountQrcodeVerification
  },
  setup(_, { emit }) {
    function closeModal() {
      emit('close')
    }

    /**
     * 扫码验证成功
     */
    function handleVerificationSuccess(token: string) {
      emit('success', token)
    }

    /**
     * 扫码验证失败
     */
    function handleVerificationError() {
      emit('error')
    }

    return {
      closeModal,
      handleVerificationSuccess,
      handleVerificationError
    }
  }
})
